import i18n from "@i18n/i18n";

/**
 * Resolves login-page.{customer}-bim-prerequisite when a translation exists for the configured customer.
 */
export function getCustomerBimPrerequisiteKey(customerName: string | null | undefined): string | null {
  if (!customerName?.trim() || !i18n.isInitialized) {
    return null;
  }

  const key = `login-page.${customerName.trim().toLowerCase()}-bim-prerequisite`;
  return i18n.exists(key) ? key : null;
}
